export const prefix = 'bcs';



// WEBPACK FOOTER //
// ./src/scripts/helpers/constants.js